import { KeyboardEventHandler, useEffect, useState } from 'react';

function useSubmitByKeyPress({
    onEnter,
    onEnterAndCmd,
}: {
    onEnter?: VoidFunction;
    onEnterAndCmd?: VoidFunction;
}): {
    handleKeyUp: KeyboardEventHandler<HTMLElement>;
    handleKeyDown: KeyboardEventHandler<HTMLElement>;
} {
    const [enterKeyPressed, setEnterKeyPressed] = useState(false);
    const [cmdKeyPressed, setCmdKeyPressed] = useState(false);

    useEffect(() => {
        if (onEnter && enterKeyPressed) {
            onEnter();
            setEnterKeyPressed(false);
        } else if (onEnterAndCmd && enterKeyPressed && cmdKeyPressed) {
            onEnterAndCmd();
            setEnterKeyPressed(false);
            setCmdKeyPressed(false);
        }
    }, [enterKeyPressed, cmdKeyPressed, onEnter, onEnterAndCmd]);

    const handleKeyDown: KeyboardEventHandler<HTMLElement> = ({ key }) => {
        if (key === 'Enter') {
            setEnterKeyPressed(true);
        } else if (key === 'Meta' || key === 'Control') {
            setCmdKeyPressed(true);
        } else {
            return;
        }
    };
    const handleKeyUp: KeyboardEventHandler<HTMLElement> = ({ key }) => {
        if (key === 'Enter' || key === 'Meta' || key === 'Control') {
            setEnterKeyPressed(false);
            setCmdKeyPressed(false);
        }
    };

    return { handleKeyUp, handleKeyDown };
}

export default useSubmitByKeyPress;
